import { useSearchParams } from "react-router-dom";

export const useFrom = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get("from");
};
